<template>
  <div class="dashboard-wrapper dashboard-wrapper--gray mainContent-wrapper">
    <div class="content">
      <ClientDashboard v-if="checkPermission(C_CLIENT_DASHBOARD)"/>
      <AdminDashboard v-if="checkPermission(C_ADMIN_DASHBOARD)"/>
    </div>
  </div>
</template>

<script>
import {C_ADMIN_DASHBOARD, C_CLIENT_DASHBOARD} from '@/shared/component_permission';
import ClientDashboard from "@/components/dashboard/ClientDashboard";
import AdminDashboard from "@/components/dashboard/AdminDashboard";
export default {
    name: 'Index',
    data() {
      return {
        C_CLIENT_DASHBOARD,
        C_ADMIN_DASHBOARD
      }
    },
    components: {AdminDashboard, ClientDashboard},


}
</script>
<style>
.dashboard-wrapper .card{
  background-color: #ffffff;
  border-radius: 10px;
  border: 1px solid #e3e3e3;
}
.dashboard-wrapper .header-1{
  font-size: 30px;
  font-weight: 400;
  line-height: 1.2;
}
.dashboard-wrapper .header-2{
  margin-bottom: 0;
  font-size: 19px;
}
.dashboard-wrapper .content {
  padding: 30px 15px;
}

</style>
